module.exports = __webpack_public_path__ + "static/media/identity-princeton.d28323b8.jpg";